import { useEffect, useRef, useState } from 'react';

// mr-mui's table keeps its own current page, so resetting the hook's position alone leaves the table
// on page 2 under the new results. react-data-table-component returns to its first page whenever
// paginationResetDefaultPage changes value, and reports that through onChangePage, so flipping it on
// each filter or sort change brings the table's page back in step.
export default function usePaginationResetToggle({ globalFilters, sortDirection }) {
  const [paginationResetDefaultPage, setPaginationResetDefaultPage] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPaginationResetDefaultPage(current => !current);
  }, [globalFilters, sortDirection]);

  return { paginationResetDefaultPage };
}
